import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';
import NoElements from '../../../components/states/NoElements';
import LoadingMotion from '../../../components/LoadingMotion';
import RightColumn from '../../../components/RightColumn';

import './taskDoctor.css';

import GenericDisplay from './GenericDisplay';
import { taskDoctorHelper } from './helpers';

import { ElementTypeActions } from '../../../actions/elementType';

import {
  dependencyTypeIdSelector,
  wbsRelTypeIdSelector,
} from '../../../reducers/relationshipTypes';
import {
  relationshipsSelector,
  relationshipsByTypeByRelId,
} from '../../../reducers/relationships';
import {
  projectStartDateSelector,
} from '../../../reducers/projects'
import {
  elementsRelationshipsSelector,
} from '../../../reducers/elementsRelationships';
import {
  elementsSelector,
  filterElementsByType,
} from '../../../reducers/elements';
import {
  taskTypeIdSelector,
} from '../../../reducers/elementTypes';
import {
  shouldLoadElementByType,
  elementsByTypeSelector,
  elementsByTypeLoadingSelector,
  elementTypeLoaded,
} from '../../../reducers/elementsByType';

const orderedWbsElementsSelector = (state, props) => props.orderedWbsElements;

const TaskDoctorContainerSelector = immutableCreatorSelector(
  [
    taskTypeIdSelector,
    elementsSelector,
    elementsRelationshipsSelector,
    projectStartDateSelector,
    relationshipsSelector,
    dependencyTypeIdSelector,
    wbsRelTypeIdSelector,
    elementsByTypeSelector,
    elementsByTypeLoadingSelector,
    orderedWbsElementsSelector,
  ],
  (
    taskTypeId,
    elements,
    elementsRelationships,
    projectStartDate,
    relationships,
    dependencyTypeId,
    wbsRelTypeId,
    elementsByType,
    elementsByTypeLoading,
    orderedWbsElements,
  ) => ({
    taskDoctor: taskDoctorHelper(
      filterElementsByType(elements, [taskTypeId]).map(e => elements.get(e)),
      elements,
      elementsRelationships,
      projectStartDate,
      relationshipsByTypeByRelId(relationships),
      dependencyTypeId,
      wbsRelTypeId,
      taskTypeId,
      relationships,
      orderedWbsElements,
    ),
    shouldLoadTasks: shouldLoadElementByType(
      taskTypeId,
      elementsByTypeLoading,
      elementsByType,
    ),
    taskTypeId,
    taskElementTypeLoaded: elementTypeLoaded(
      elementsByType,
      taskTypeId,
    ),
    tasks: filterElementsByType(elements, [taskTypeId]),
  }),
);

@connect(TaskDoctorContainerSelector)
class TaskDoctor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      healthScore: null,
      currentElement: null,
    }
  }

  componentWillMount = () => {
    this.retrieveTasks(this.props);
  }

  componentWillReceiveProps = (nextProps) => {
    this.retrieveTasks(nextProps);
  }

  retrieveTasks = (props) => {
    const { taskTypeId, shouldLoadTasks, dispatch, taskDoctor, tasks } = props;

    if (taskTypeId && shouldLoadTasks) {
      dispatch(ElementTypeActions.getElementsByType(taskTypeId));
    }

    if (!shouldLoadTasks) {
      const totalProblems = Object.keys(taskDoctor).reduce((p, c) => {
        return p + taskDoctor[c].length;
      }, 0)

      const problemPercentage = totalProblems ? totalProblems / tasks.size : 0;

      this.setState({
        healthScore: problemPercentage,
      });
    }
  }

  textMap = {
    finishDatePreceedStart: {
      title: 'Tasks That Have Finish Dates That Are Before Their Own Start Dates',
      suggestion: '* Fill in data*',
      icon: 'fa fa-calendar',
      help: '',
    },
    finishedBeforePred: {
      title: 'Tasks That Have Been Started Before Their Predecessors Have Finished',
      suggestion: '* Fill in data*',
      icon: 'fa fa-calendar',
      help: '',
    },
    startDatePreceedsProjectStart:  {
      title: 'Tasks That Have Start Dates That Are Before the Project Start Date',
      suggestion: '* Fill in data*',
      icon: 'fa fa-calendar',
      help: '',
    },
    finishDatePreceedsProjectStart: {
      title: 'Tasks That Have Finish Dates That Are Before the Project Start Date',
      suggestion: '* Fill in data*',
      icon: 'fa fa-calendar',
      help: '',
    },
    taskProgressWithoutStartDate: {
      title: 'Tasks That Have Made Progress But Have No Start Date',
      suggestion: '* Fill in data*',
      icon: 'fa fa-calendar',
      help: '',
    },
    taskProgressWithoutResponsibileUser: {
      title: 'Task That Have Made Progress But Have No Responsible User Assigned',
      suggestion: '* Fill in data*',
      icon: 'fa fa-user',
      help: '',
    },
    taskHasNoRelationships: {
      title: 'Tasks That Have No Dependency Relationships',
      suggestion: '* Fill in data*',
      icon: 'fa fa-link',
      help: '',
    },
    wbsElementsWithNoChildren: {
      title: 'WBS Level Has No Associated Tasks or Milestones',
      suggestion: '* Fill in data*',
      icon: 'fa fa-link',
      help: '',
    }
  }

  handleRightPanelClose = () => {
    this.setState({
      currentElement: null,
    })
  }

  openRightPanel = (element) => {
    this.setState({
      currentElement: element,
    })
  }

  determineHealth = (healthScore) => {
    if (healthScore > 1) {
      return <i className="fa fa-4x fa-frown-o" style={{ color: 'red' }} aria-hidden="true"></i>
    } else if (healthScore <= 0.25) {
      return <i className="fa fa-4x fa-smile-o" style={{ color: 'green' }} aria-hidden="true"></i>
    } else {
      return <i className="fa fa-4x fa-meh-o" style={{ color: 'orange' }} aria-hidden="true"></i>
    }
  }

  determineRightbar() {
    const { currentElement } = this.state;

    if (currentElement) {
      return (
        <RightColumn
          entity={currentElement}
          callback={this.handleRightPanelClose}
          entityType={'element'}
          flexOverride
        />
      );
    }

    return <div />;
  }

  buildSections = (taskDoctor) => {
    const sections = Object.keys(taskDoctor);

    if (sections.length) {
      return sections.map((type, k) => {
        const data = this.textMap[type];

        return (
          <GenericDisplay
            tasks={taskDoctor[type]}
            title={data.title}
            suggestion={data.suggestion}
            key={k}
            openRightPanel={this.openRightPanel}
            icon={data.icon}
          />
        )
      })
    } else {
      return (
        <div className="col">
          <NoElements missingType="problems" />
        </div>
      )
    }
  }

  render() {
    const { taskDoctor, taskElementTypeLoaded } = this.props;

    const face = this.determineHealth(this.state.healthScore);

    if (!taskElementTypeLoaded) {
      return <LoadingMotion loadingMessage="The doctor is working..." />;
    }

    const sections = Object.keys(taskDoctor);
    const problemMessage = sections.length ? <div>Your Project is Suffering from the Following Ailments</div> : null;

    return (
      <div style={{ display: 'flex', flexDirection: 'row', padding: 0, flex: '1' }}>
        <div
          style={{
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            padding: '0 15px',
            background: 'rgb(241, 241, 241)',
            overflowY: 'auto',
          }}
        >
          <div className="task-doctor">
            <div className="header-col" style={{ display: 'flex', flexDirection: 'row' }}>
              <div style={{ width: '95%', flexDirection: 'column' }}>
                <h2><i className="fa fa-user-md" aria-hidden="true"></i> Task Doctor</h2>
                { problemMessage }
              </div>
              <div style={{ justifyContent: 'center' }}>
                {face}
              </div>
            </div>
          </div>
          <div className="task-doctor flex-grid">
            { this.buildSections(taskDoctor) }
          </div>
        </div>
        {
          this.determineRightbar()
        }
      </div>
    )
  }
}

TaskDoctor.propTypes = {
  taskDoctor: PropTypes.object,
  shouldLoadTasks: PropTypes.bool,
  taskTypeId: PropTypes.string,
  taskElementTypeLoaded: PropTypes.bool,
  tasks: PropTypes.array,
};

export default TaskDoctor;



// WEBPACK FOOTER //
// ./src/views/Project/TaskDoctor/TaskDoctor.js